import Exception from '../exception/exception';
export default class AbstractTask {
    /**
     * Returns whether the request should be authenticated
     */
    get authenticated() {
        return true;
    }
    /**
     * Returns query string parameters
     */
    get params() {
        return null;
    }
    /**
     * Returns the headers for the request
     */
    get headers() {
        const headers = {};
        // Add the token if this is an authenticated request
        if (this.authenticated && this.token) {
            headers.Authorization = `Bearer ${this.token}`;
        }
        const customHeaders = this.customHeaders;
        for (const key in customHeaders) {
            headers[key] = customHeaders[key];
        }
        return headers;
    }
    /**
     * Returns the headers which are custom for the request
     */
    get customHeaders() {
        return {};
    }
    /**
     * Generates params from a data object
     *
     * @param data
     * @returns
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    generateParamsFromData(data) {
        if (!data) {
            return null;
        }
        const params = {};
        for (const key in data) {
            // Sorting
            if (key === 'order') {
                const values = data[key];
                for (const value of values) {
                    params[`order[${value.key}]`] = value.descending ? 'desc' : 'asc';
                }
            }
            // Conditions
            else {
                const value = data[key];
                if (Array.isArray(value) && value.length > 0) {
                    const values = [];
                    for (const currentValue of value) {
                        values.push(this.getParamValue(currentValue));
                    }
                    params[key] = values;
                }
                else if (value !== '' && value !== null && value !== undefined) {
                    params[key] = this.getParamValue(value);
                }
            }
        }
        return params;
    }
    /**
     * Gets a string value for a param value
     *
     * @param value
     * @returns
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getParamValue(value) {
        switch (typeof value) {
            case 'boolean':
                return value ? '1' : '0';
            case 'bigint':
            case 'number':
                return `${value}`;
            case 'symbol':
                return value.description;
            case 'string':
            default:
                return value;
        }
    }
    /**
     * Return the http code that signals a successfull call
     */
    get successCode() {
        return 200;
    }
    /**
     * Throw the relevant error for the given status
     *
     * @param status number
     */
    handleErrorResponse(status) {
        var _a;
        const error = (_a = this.errorCodes[status]) !== null && _a !== void 0 ? _a : Exception.UnknownError;
        throw new Error(error);
    }
    /**
     * Return the error codes in the format http code => error
     */
    get errorCodes() {
        return {
            400: Exception.InvalidInput,
            401: Exception.InvalidDetails,
            403: Exception.AccessDenied,
            404: Exception.NotFound,
            422: Exception.UnprocessableEntity,
        };
    }
}
//# sourceMappingURL=abstract-task.js.map